import { Button, Chip, IconButton, Stack, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGetAllStore from "../../../hooks/store/useGetAllStore";
import { IStore } from "../../../utils/interfaces/IStore";
import {
  Store,
  Add,
  Refresh,
  Edit,
  PersonAdd,
} from "@mui/icons-material";
import { GridColDef } from "@mui/x-data-grid";
import Grid from "@mui/material/Unstable_Grid2";
import DataGridCustom from "../../../components/DataGridCustom";

interface IHooksLoja {
  data: IStore[] | any[];
  error: any;
  isLoading: boolean;
  requestUpdate: () => void;
}

function StoreListPage() {
  const navigate = useNavigate();
  const { data, isLoading, requestUpdate }: IHooksLoja = useGetAllStore();
  const [lojas, setLojas] = useState<any[]>([]);
  const profile = localStorage.getItem('profile')
  useEffect(() => {
    try {
      if (data) {
        const novoArray = data.map((item) => ({
          id: item.storeModel.idLoja,
          nome: `${item.storeModel.idBranchLoja} -- ${item.storeModel.nomeRestaurante}`,
          endereco: item.endereco,
          telefoneLoja: item.storeModel.telefoneLoja,
          emailLoja: item.storeModel.emailLoja,
          codFranqueado: item.storeModel.codFranqueado,
        }));
        setLojas(novoArray);
      }
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const columns: GridColDef[] = [
    {
      field: "nome",
      headerName: "Nome da Loja",
      width: 300,
    },
    { field: "endereco", headerName: "Endereço", width: 200 },
    { field: "telefoneLoja", headerName: "Telefone", width: 200 },
    { field: "emailLoja", headerName: "Endereço de e-mail", width: 200 },
    {
      field: "codFranqueado",
      headerName: "Código do Franqueado",
      width: 200,
    },
  ];
  if (profile === 'ADMIN') {
    columns.push({
      field: "actions",
      headerName: "Opções",
      sortable: false,
      filterable: false,
      disableExport: true,
      headerAlign: "center",
      align: "center",
      description:
        "Esta coluna tem um renderCell de valor e não pode ser classificada ou filtrada.",
      width: 150,
      renderCell: (params: any) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Tooltip title="Adicionar Utilizador">
              <IconButton
                onClick={() => {
                  navigate(`/user-store/${params.row.id}`);
                }}
                color="warning"
              >
                <PersonAdd />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  navigate(`/store-edit/${params.row.id}`);
                }}
                color="info"
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    });
  }
  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<Store color="info" />} label="Lojas" />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <DataGridCustom
          rows={lojas}
          getRowId={(row: any) => row.id}
          columns={columns}
          loading={isLoading}
          pageSize={20}
          customButton={
            <React.Fragment>
              {profile ==='ADMIN' && (
              <Button
                color="success"
                startIcon={<Add />}
                size="small"
                onClick={() => navigate("/store-register")}
              >
                Adicionar Loja
              </Button>
)}
              <Button
                startIcon={<Refresh />}
                size="small"
                onClick={() => {
                  requestUpdate();
                }}
              >
                Atualizar
              </Button>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}
export default StoreListPage;
